// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface WrenchIconSignature {
  Element: SVGSVGElement;
}

export const WrenchIcon: TOC<WrenchIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.334 2.40702C17.125 3.39402 19 6.04402 19 9.00002C19 11.785 17.361 14.188 15 15.315V22H13V16H11V22H9V15.315C6.639 14.188 5 11.786 5 9.00002C5 6.04402 6.875 3.39402 9.666 2.40702L11 1.93402V8.00002C11 8.55302 11.449 9.00002 12 9.00002C12.551 9.00002 13 8.55302 13 8.00002V1.93402L14.334 2.40702ZM7 9.00002C7 11.757 9.243 14 12 14C14.757 14 17 11.756 17 9.00002C17 7.40402 16.234 5.93402 15 5.00602V8.00002C15 9.65402 13.654 11 12 11C10.346 11 9 9.65402 9 8.00002V5.00702C7.766 5.93502 7 7.40502 7 9.00002Z"/>
</svg>
</template>;